// extracted by mini-css-extract-plugin
export var navbarSubLink = "D_f9 d_f9 d_f3 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "D_tx d_fZ d_dz";
export var subPageLink = "D_gd d_gd";
export var burger = "D_tW";
export var sublinkSize = "D_tX";
export var linkSize = "D_tY";
export var Link = "D_rs q_rs q_qN q_q6";